import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CoEventCheckinPage } from './co-event-checkin';
import { PipesModule } from '../../pipes/pipes.module';
import { ComponentsModule } from '../../components/components.module';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    CoEventCheckinPage,
  ],
  imports: [
    IonicPageModule.forChild(CoEventCheckinPage),
    PipesModule,
    ComponentsModule,
    DirectivesModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
]
})
export class CoEventCheckinPageModule {}



// WEBPACK FOOTER //
// ./src/pages/co-event-checkin/co-event-checkin.module.ts